/**
 * Màu của vai trò được **suy ra từ tên bằng một hàm băm cố định**, không bao
 * giờ lưu (§9.10).
 *
 * Nhờ vậy cùng một vai trò luôn có cùng màu ở mọi màn hình, nên người dùng nhận
 * ra "Kế toán trưởng" qua chip xanh trước cả khi đọc chữ. Hai bản sao của hàm
 * này sẽ trôi lệch nhau và phá âm thầm manh mối đó — nên chỉ có đúng một bản.
 */
const ROLE_COLORS = [
  'bg-primary-500',
  'bg-violet-500',
  'bg-success-600',
  'bg-teal-500',
  'bg-orange-500',
  'bg-sky-500',
  'bg-danger-500',
  'bg-warning-600',
] as const;

/** Băm chuỗi thành chỉ số ổn định. Dùng chung cho vai trò và phòng ban. */
export function hashKey(key: string): number {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) & 0xffff;
  return h;
}

export function roleColor(name: string): string {
  return ROLE_COLORS[hashKey(name) % ROLE_COLORS.length] ?? ROLE_COLORS[0];
}

export function roleInitials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/** Bộ ba màu cho phòng ban: thanh biểu đồ, chữ, chip (§8.1). */
export interface CategoricalColor {
  bar: string;
  text: string;
  chip: string;
}

const CATEGORICAL: readonly CategoricalColor[] = [
  { bar: 'bg-primary-500', text: 'text-primary-700', chip: 'bg-primary-50' },
  { bar: 'bg-violet-500', text: 'text-violet-700', chip: 'bg-violet-50' },
  { bar: 'bg-teal-500', text: 'text-teal-700', chip: 'bg-teal-50' },
  { bar: 'bg-sky-500', text: 'text-sky-700', chip: 'bg-sky-50' },
  { bar: 'bg-orange-500', text: 'text-orange-700', chip: 'bg-orange-50' },
  { bar: 'bg-success-500', text: 'text-success-700', chip: 'bg-success-50' },
];

/** Cùng một phòng ban giữ một màu trên khắp màn hình. */
export function catColor(key: string): CategoricalColor {
  return CATEGORICAL[hashKey(key) % CATEGORICAL.length] ?? CATEGORICAL[0]!;
}
